import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import * as Config from "eai-configurator-ui/components/configuration/utils/ConfigurationRegistry";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import { Type } from "react-bootstrap-table2-editor";
import { dateFilter, selectFilter, textFilter } from "react-bootstrap-table2-filter";
import TableAsyncTypeAheadEditor from "eai-configurator-ui/components/configuration/table/TableAsyncTypeAheadEditor";
import Moment from "moment";
import IconButton from "@material-ui/core/IconButton";
import NewIcon from "@material-ui/icons/FiberNew";
export var createComboBoxEditorColumn = function createComboBoxEditorColumn(path, showFilter, props) {
  var config = Config.getDefault(path);
  var options = Object.entries(config.data.valueMap).map(function (entry) {
    return Object({
      value: entry[0],
      label: entry[1]
    });
  });
  return _objectSpread({
    dataField: config.key,
    text: config.data.label,
    sort: true,
    bulkEditable: true,
    editor: {
      type: Type.SELECT,
      options: options
    },
    formatter: function formatter(cell, row) {
      return options.find(function (x) {
        return x.value === cell;
      }).label;
    },
    filter: showFilter ? selectFilter({
      options: options
    }) : undefined
  }, props);
};
export var createCheckBoxEditorColumn = function createCheckBoxEditorColumn(path, showFilter, props) {
  var config = Config.getDefault(path);
  return _objectSpread({
    dataField: config.key,
    text: config.data.label,
    sort: true,
    headerStyle: {
      width: "120px"
    },
    editor: {
      type: Type.CHECKBOX,
      value: "true:false"
    },
    formatter: function formatter(cell, row, rowIndex) {
      return /*#__PURE__*/React.createElement("div", null, String(cell) === "true" ? "Yes" : "No");
    },
    filter: showFilter ? selectFilter({
      options: {
        true: "Yes",
        false: "No"
      }
    }) : undefined
  }, props);
};
export var createTextEditorColumn = function createTextEditorColumn(path, showFilter, props) {
  var config = Config.getDefault(path);
  return _objectSpread({
    dataField: config.key,
    text: config.data.label,
    sort: true,
    filter: showFilter ? textFilter() : undefined,
    bulkEditable: true
  }, props);
};
export var createDateEditorColumn = function createDateEditorColumn(path, showFilter, props) {
  var config = Config.getDefault(path);
  return _objectSpread({
    dataField: config.key,
    text: config.data.label,
    type: "date",
    sort: true,
    filter: showFilter ? dateFilter() : undefined,
    editable: false,
    formatter: function formatter(cell, row, rowIndex) {
      var num = parseInt(cell);
      return num ? Moment(new Date(num)).format("DD-MMM-YYYY HH:mm") : "-";
    }
  }, props);
};
export var createTextTypeAheadEditorColumn = function createTextTypeAheadEditorColumn(path, showFilter, url, queryDataTransformer, props) {
  var config = Config.getDefault(path);
  var result = {
    dataField: config.key,
    text: config.data.label,
    sort: true,
    filter: showFilter ? textFilter() : undefined,
    bulkEditable: true
  };
  if (url) {
    result.editorRenderer = function (editorProps, value, row, column, rowIndex, columnIndex) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, props && props.rolldown && props.rolldownClick && /*#__PURE__*/React.createElement(IconButton, {
        onClick: props.rolldownClick
      }, /*#__PURE__*/React.createElement(NewIcon, {
        style: {
          color: "red"
        }
      })), /*#__PURE__*/React.createElement(TableAsyncTypeAheadEditor, Object.assign({}, editorProps, {
        row: row,
        url: url instanceof Function ? url(row) : url,
        value: value,
        queryDataTransformer: queryDataTransformer
      }, props)));
    };
  }
  return result;
};
export var createDataIndexEditorColumn = function createDataIndexEditorColumn() {
  return {
    dataField: "dataIndex",
    hidden: true,
    type: "number"
  };
};